<template>
  <v-app-bar app color="white darken-2" dark>
    <v-toolbar-title class="black--text">
      <v-btn class="black--text" @click="goHome" text tile depressed>
        Robin Lange
      </v-btn>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <div>
      <v-btn class="black--text py-2" tile text to="/about">About</v-btn>
      <v-btn class="black--text py-2" tile text to="/blog">Blog</v-btn>
      <v-menu offset-y open-on-hover>
        <template v-slot:activator="{ on }">
          <v-btn class="black--text py-2" v-on="on" tile text>
            Tools
            <v-icon right>fa-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in toolLinks"
            :key="index"
            :to="item.link"
          >
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn class="black--text py-2" to="/services" tile text>
        Services
      </v-btn>
      <v-btn class="black--text py-2" to="/contact" tile text>Contact Us</v-btn>
    </div>
  </v-app-bar>
</template>

<script>
export default {
  name: "AppBar",
  data: () => ({
    toolLinks: [
      { name: "Plate Calculator", link: "/platecalc", icon: "mdi-calculator" },
      { name: "BMR Calculator", link: "/bmrcalc", icon: "mdi-scale" },
      { name: "Macro Calculator", link: "/macrocalc", icon: "mdi-food" },
    ],
  }),
  methods: {
    goHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style></style>
